<template>
  <v-row v-if="condition">
    <v-col class="d-flex flex-col align-center loading-bar">
      <svg class="loading-spinner">
        <circle :cx="circlePositions[index] && circlePositions[index].x"
          :cy="circlePositions[index] && circlePositions[index].y" :r="item.radius" :fill="item.color"
          v-for="(item, index) in circles" :key="index" />
      </svg>
      {{ !message ? $t("loading") : message }}
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "LoadingBar",
  data() {
    return {
      circles: [
        { color: "#E0F7FA", radius: 0 },
        { color: "#B2EBF2", radius: 0 },
        { color: "#80DEEA", radius: 0 },
        { color: "#4DD0E1", radius: 0 },
        { color: "#26C6DA", radius: 0 },
        { color: "#00BCD4", radius: 0 },
        { color: "#00ACC1", radius: 0 },
        { color: "#0097A7", radius: 0 },
        { color: "#00838F", radius: 0 },
      ],
      counter: 0,
      interval: null,
      CENTER_X: 15,
      CENTER_Y: 15,
      RADIUS: 10
    };
  },
  props: {
    message: String,
    condition: Boolean,
  },
  computed: {
    circlePositions() {
      let angleIncrement = 360 / this.circles.length;
      let positions = {};
      this.circles.forEach((circle, index) => {
        positions[index] = this.positionOnCircle(this.RADIUS, angleIncrement * index, {
          x: this.CENTER_X,
          y: this.CENTER_Y,
        });
      });
      return positions;
    },
  },
  created() {
    this.interval = setInterval(() => {
      this.counter++;
      this.circles = this.circles.map((item, index) => ({
        ...item,
        radius: (this.counter + index) % 5,
      }));
    }, 100);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    positionOnCircle(radius, angle, center) {
      return {
        x: center.x + radius * Math.cos(this.toRadians(angle)),
        y: center.y + radius * Math.sin(this.toRadians(angle)),
      };
    },
    toRadians(angle) {
      return (angle * Math.PI) / 180;
    },
  }
};
</script>

<style scoped>
.loading-spinner {
  width: 50px;
  height: 50px;
}

.loading-bar {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>